<template>
  <div>
    <v-subheader>Displaying last 10 modified history</v-subheader>
    <v-stepper :value="audits.length - 1" vertical class="policyLifeCycle">
      <template v-for="(audit, index) in audits">
        <v-stepper-step :step="index" :complete="true" :key="index">
          {{audit.name}}
        </v-stepper-step>
        <v-stepper-content :step="index" :key="audit.reviewDate">
          <div>
            <v-icon>mdi-calendar-clock</v-icon>
            <span>{{formatDateTime(audit.reviewDate)}}</span>
          </div>
        </v-stepper-content>
      </template>
    </v-stepper>
  </div>
</template>

<script>
import { formatDisplayDateTime } from '@/utils/date'

export default {
  computed: {
    audits() {
      return this.$store.state.agency.quotation.commonInfo.audits
    }
  },
  methods: {
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    }
  }
}
</script>

<style lang="scss">
</style>
